import React, { useEffect, useRef } from 'react';
import { Modal, Button, Row, Col } from 'antd';
import IssueApi from '@/fetch/bussiness/issue';
import { useSelector } from 'react-redux';
import { HttpStatusCode } from '@/fetch/core/constant';
import { debounce, showMsg } from '@/utils/util';
import { IssueStatus } from '@/utils/type';
import { RootState } from '@/redux/store';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
  sendGlobalEvent,
} from '@/utils/emit';
interface Props {
  open: boolean;
  setOpen: AnyFunc;
  vehicleName: string;
  LC_BUTTON_L2?: boolean;
  issueNumber: string | undefined;
  showOnHold: boolean;
  showCancelOnHold: boolean;
}
const fetchApi = new IssueApi();
const OnHoldIssueModal = (props: Props) => {
  const {
    open,
    setOpen,
    vehicleName,
    LC_BUTTON_L2,
    issueNumber,
    showOnHold,
    showCancelOnHold,
  } = props;
  const { list } = useSelector((state: RootState) => state.issue);
  const keyboardUsed = useRef<boolean>(false);
  const confirmOnHold = async () => {
    if (!issueNumber) {
      return;
    }
    try {
      const res = await fetchApi.holdIssue({
        issueNumber: issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        showMsg({
          msg: '挂单成功',
          type: 'success',
        });
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOpen(false);
    }
  };
  const confirmCancelHold = async () => {
    if (!issueNumber) {
      return;
    }
    try {
      const res = await fetchApi.cancelHoldIssue({
        issueNumber: issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        showMsg({
          msg: '取消挂单成功',
          type: 'success',
        });
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (!props.issueNumber) {
      return;
    }
    if (LC_BUTTON_L2) {
      if (keyboardUsed.current == false) {
        keyboardUsed.current = true;
        setOpen(true);
        sendGlobalEvent('CLOSE_OTHER_MODAL', 'onHoldIssueModal');
      } else {
        keyboardUsed.current = false;
        if (showOnHold) {
          debounce(confirmOnHold, 500)();
        } else if (showCancelOnHold) {
          debounce(confirmCancelHold, 500)();
        }
      }
    }
  }, [LC_BUTTON_L2, issueNumber]);

  useEffect(() => {
    const cb = (modalName: string) => {
      if (modalName === 'onHoldIssueModal') {
        return;
      }
      keyboardUsed.current = false;
      setOpen(false);
    };
    addGlobalEventListener('CLOSE_OTHER_MODAL', cb);
    return () => {
      removeGlobalEventListener('CLOSE_OTHER_MODAL', cb);
    };
  }, []);
  const renderContent = () => {
    if (!Array.isArray(list)) {
      return <></>;
    }
    if (showOnHold) {
      const hasHoldIssue = list?.find(
        (issue: any) => issue.issueStatus === IssueStatus.ON_HOLD
      );
      if (hasHoldIssue) {
        return (
          <Row>
            <Col>
              <img
                width={36}
                height={36}
                style={{ marginRight: '6px' }}
                src={require('@/assets/images/cockpit/warning_icon.png')}
              ></img>
            </Col>
            <Col style={{ maxWidth: '92%' }}>
              当前座席有挂起工单，挂起当前工单后，原挂起工单将被受理，是否确认挂单?
            </Col>
          </Row>
        );
      } else {
        return (
          <Row
            justify={'center'}
            align={'middle'}
            style={{ marginTop: '60px' }}
          >
            <Col>
              <img
                width={36}
                height={36}
                style={{ marginRight: '6px' }}
                src={require('@/assets/images/cockpit/warning_icon.png')}
              ></img>
            </Col>
            <Col>您是否确认挂单？</Col>
          </Row>
        );
      }
    } else if (showCancelOnHold) {
      const hasProcessIssue = list?.find(
        (issue: any) => issue.issueStatus === IssueStatus.PROCESS
      );
      if (hasProcessIssue) {
        return (
          <Row justify={'center'} align={'middle'}>
            <Col>
              <img
                width={36}
                height={36}
                style={{ marginRight: '6px' }}
                src={require('@/assets/images/cockpit/warning_icon.png')}
              ></img>
            </Col>
            <Col style={{ maxWidth: '92%' }}>
              当前座席有受理中工单，受理当前工单后，原受理中工单将被挂起，是否取消挂起当前工单？
            </Col>
          </Row>
        );
      } else {
        return (
          <Row justify={'center'} align={'middle'}>
            <Col>
              <img
                width={36}
                height={36}
                style={{ marginRight: '6px' }}
                src={require('@/assets/images/cockpit/warning_icon.png')}
              ></img>
            </Col>
            <Col>您是否取消挂单？</Col>
          </Row>
        );
      }
    }
    return <></>;
  };

  return (
    <>
      <Modal
        width={800}
        open={open}
        onCancel={() => setOpen(false)}
        centered
        destroyOnClose
        footer={
          <>
            <div className="footer">
              <div className="operate">
                <Button
                  onClick={() => {
                    setOpen(false);
                    keyboardUsed.current = false;
                  }}
                  style={{
                    marginRight: '12px',
                  }}
                >
                  取消
                </Button>
                <Button
                  type={'primary'}
                  onClick={() => {
                    if (showOnHold) {
                      confirmOnHold();
                    } else if (showCancelOnHold) {
                      confirmCancelHold();
                    }
                  }}
                >
                  确定
                </Button>
              </div>
            </div>
          </>
        }
      >
        {renderContent()}
      </Modal>
    </>
  );
};
export default React.memo(OnHoldIssueModal);
